import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { MARKET_SEGMENTS } from '../data/mockData';

// 区块5：目标市场规模细分（饼图）
export default function ChartPieMarket() {
  const colors = ['#fbbf24', '#06b6d4', '#22c55e', '#f97316'];
  const option = {
    backgroundColor: 'transparent',
    title: {
      text: '目标市场规模细分',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 20, fontWeight: 'bold' },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c}% ({d}%)',
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    legend: {
      orient: 'vertical',
      right: 20,
      top: 'center',
      textStyle: { color: '#cbd5e1', fontSize: 14 },
    },
    series: [
      {
        name: '市场规模',
        type: 'pie',
        radius: ['40%', '65%'],
        center: ['40%', '55%'],
        avoidLabelOverlap: true,
        itemStyle: {
          borderRadius: 8,
          borderColor: '#0f172a',
          borderWidth: 3,
        },
        label: {
          show: true,
          formatter: '{b}\n{d}%',
          color: '#fff',
          fontSize: 14,
          fontWeight: 'bold',
        },
        labelLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } },
        data: MARKET_SEGMENTS.map((item, index) => ({
          ...item,
          itemStyle: { color: colors[index] },
        })),
        animationType: 'scale',
        animationEasing: 'elasticOut',
        animationDuration: 1500,
      },
    ],
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 400 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
